// Generated by Melange

import * as Buhta_payrollapis__Buhta_payroll_v1_salary from "./buhta_payroll_v1_salary.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment.ml",
      80,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Employment"
                    ]]
                },
                "V1alpha2"
              ]]
          },
          "Payroll"
        ]]
    });

const Payroll = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment.ml",
      120,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Employment"
              ]]
          },
          "V1alpha2"
        ]]
    });

const V1alpha2 = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment.ml",
      158,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Employment"
        ]]
    });

const Employment = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment.ml",
      194,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.v1alpha2.Employment";
}

function make(idOpt, create_time, update_time, positionOpt, start_date, terminate_date, salary, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const position = positionOpt !== undefined ? positionOpt : "";
  return {
          id: id,
          create_time: create_time,
          update_time: update_time,
          position: position,
          start_date: start_date,
          terminate_date: terminate_date,
          salary: salary
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_update_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "update_time",
            "updateTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const merge_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "position",
            "position"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$2 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_start_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            9,
            "start_date",
            "startDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_terminate_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            10,
            "terminate_date",
            "terminateDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const $$let$4 = Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryRate;

const merge_salary = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            11,
            "salary",
            "salary"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
          update_time: Curry._2(merge_update_time, t1.update_time, t2.update_time),
          position: Curry._2(merge_position, t1.position, t2.position),
          start_date: Curry._2(merge_start_date, t1.start_date, t2.start_date),
          terminate_date: Curry._2(merge_terminate_date, t1.terminate_date, t2.terminate_date),
          salary: Curry._2(merge_salary, t1.salary, t2.salary)
        };
}

function spec(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$3 = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$4 = Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryRate;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "create_time",
                        "createTime"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "update_time",
                            "updateTime"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let$1.name,
                                make: $$let$1.make,
                                from_proto: $$let$1.from_proto,
                                from_proto_exn: $$let$1.from_proto_exn,
                                to_proto: $$let$1.to_proto,
                                to_proto$p: $$let$1.to_proto$p,
                                merge: $$let$1.merge,
                                to_json: $$let$1.to_json,
                                from_json_exn: $$let$1.from_json_exn,
                                from_json: $$let$1.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                8,
                                "position",
                                "position"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    9,
                                    "start_date",
                                    "startDate"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let$2.name,
                                        make: $$let$2.make,
                                        from_proto: $$let$2.from_proto,
                                        from_proto_exn: $$let$2.from_proto_exn,
                                        to_proto: $$let$2.to_proto,
                                        to_proto$p: $$let$2.to_proto$p,
                                        merge: $$let$2.merge,
                                        to_json: $$let$2.to_json,
                                        from_json_exn: $$let$2.from_json_exn,
                                        from_json: $$let$2.from_json
                                      })
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        10,
                                        "terminate_date",
                                        "terminateDate"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: $$let$3.name,
                                            make: $$let$3.make,
                                            from_proto: $$let$3.from_proto,
                                            from_proto_exn: $$let$3.from_proto_exn,
                                            to_proto: $$let$3.to_proto,
                                            to_proto$p: $$let$3.to_proto$p,
                                            merge: $$let$3.merge,
                                            to_json: $$let$3.to_json,
                                            from_json_exn: $$let$3.from_json_exn,
                                            from_json: $$let$3.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            11,
                                            "salary",
                                            "salary"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: $$let$4.name,
                                                make: $$let$4.make,
                                                from_proto: $$let$4.from_proto,
                                                from_proto_exn: $$let$4.from_proto_exn,
                                                to_proto: $$let$4.to_proto,
                                                to_proto$p: $$let$4.to_proto$p,
                                                merge: $$let$4.merge,
                                                to_json: $$let$4.to_json,
                                                from_json_exn: $$let$4.from_json_exn,
                                                from_json: $$let$4.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._8(serialize, writer, param.id, param.create_time, param.update_time, param.position, param.start_date, param.terminate_date, param.salary);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, create_time, update_time, position, start_date, terminate_date, salary) {
  return {
          id: id,
          create_time: create_time,
          update_time: update_time,
          position: position,
          start_date: start_date,
          terminate_date: terminate_date,
          salary: salary
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha2.Employment", spec(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.id, param.create_time, param.update_time, param.position, param.start_date, param.terminate_date, param.salary);
  };
}

function constructor$1(id, create_time, update_time, position, start_date, terminate_date, salary) {
  return {
          id: id,
          create_time: create_time,
          update_time: update_time,
          position: position,
          start_date: start_date,
          terminate_date: terminate_date,
          salary: salary
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha2.Employment", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Employment, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Employment"
        ]]
    }, V1alpha2, {
      Employment: Employment
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Employment"
              ]]
          },
          "V1alpha2"
        ]]
    }, Payroll, {
      V1alpha2: V1alpha2
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Employment"
                    ]]
                },
                "V1alpha2"
              ]]
          },
          "Payroll"
        ]]
    }, Buhta, {
      Payroll: Payroll
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
